export default {
    "apiHost": "https://api.hellodoctor.com.mx",
    "castServiceHost": "https://cast-service-pusuheofiq-uc.a.run.app",
	"firebase": {
		"apiKey": "AIzaSyAMOQYXSgQHaazbAAAMEoFO7xY60DnNk-M",
        "authDomain": "hellodoctor-production-303000.firebaseapp.com",
        "projectId": "hellodoctor-production-303000",
        "storageBucket": "hellodoctor-production-303000.appspot.com",
        "messagingSenderId": "24316860364",
        "appId": "1:24316860364:web:fd23b96ef53efe07772f69",
        "measurementId": "G-SWRBFNLN36"
	}
}
